import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack } from "@mantine/core";
import SEO from "@modules/seo/SEO";
import type React from "react";
import ValorantHeroBanner from "../components/ValorantHeroBanner";
import ValorantHowToBuyProduct from "../components/ValorantHowToBuyProduct";
import ValorantInfoCards from "../components/ValorantInfoCards";
import ValorantNeedHelpBanner from "../components/ValorantNeedHelpBanner";
import ValorantAccountCards from "../components/ValorantProductCards";
import ValorantReviewCarousel from "../components/ValorantReviewCarousel";
import ValorantDualInfoAreaExplanation from "../components/dual-info-area/ValorantDualInfoAreaExplanation";
import ValorantDualInfoAreaQuestions from "../components/dual-info-area/ValorantDualInfoAreaQuestions";
import ValorantFAQ from "../components/faq/ValorantFAQ";

const ValorantPage: React.FC = () => {
  const { t } = useAppTranslation("pages.valorant.seo");
  return (
    <>
      <SEO title={t("title")} description={t("description")} />
      <Stack align="center" className="gap-20 xl:gap-[65px]">
        <ValorantHeroBanner />

        <ValorantAccountCards />

        <ValorantInfoCards />

        <ValorantReviewCarousel />

        <ValorantDualInfoAreaExplanation />

        <ValorantNeedHelpBanner />

        <ValorantHowToBuyProduct />

        <ValorantFAQ />

        <ValorantDualInfoAreaQuestions />
      </Stack>
    </>
  );
};

export default ValorantPage;
